import * as React from 'react';
import { classes, st } from './MediaLabel.st.css';
import {
  MEDIA_LABEL_ICON_DATA_HOOK,
  MEDIA_LABEL_TEXT_DATA_HOOK,
} from './dataHooks';
import {
  MediaLabelProps,
  MediaLabelDefaultProps,
  MediaLabelSize,
} from './types';

/** An indication over media components, includes a background, text and an icon. can choose a size: small/large and to present text, icon or both  */
export class MediaLabel extends React.Component<MediaLabelProps> {
  static displayName = 'MediaLabel';
  static defaultProps: MediaLabelDefaultProps = {
    size: 'large',
  };

  render() {
    const { className, text, icon, size } = this.props;

    return (
      <div
        className={st(
          classes.root,
          { withIcon: !!icon, smallMediaLabel: size === MediaLabelSize.small },
          className,
        )}
        dir="ltr"
        aria-hidden="true"
        data-hook={this.props['data-hook']}
      >
        {icon && (
          <span className={classes.icon} data-hook={MEDIA_LABEL_ICON_DATA_HOOK}>
            {icon}
          </span>
        )}
        {text && (
          <span className={classes.text} data-hook={MEDIA_LABEL_TEXT_DATA_HOOK}>
            {text}
          </span>
        )}
      </div>
    );
  }
}
